export const VALOR_EXPEDIENTE_VACIO = 'Sin registrar';

export const CAMPOS_EXPEDIENTE = [
  'vacunas',
  'viajesRecientes',
  'lugarOrigen',
  'alimentacion',
  'agua',
  'vivienda',
  'alergias',
  'transfucionesSangre',
  'cirugiasPrevias',
  'traumasFracturasPrev',
  'enfermedadesConcomitantes',
  'diabetes',
  'hipertension',
  'asma',
  'epoc',
  'antecedenteCancer',
  'antecedentesTuberculosis',
] as const;

export function expedienteEnBlanco(): Record<string, string> {
  return Object.fromEntries(CAMPOS_EXPEDIENTE.map((campo) => [campo, VALOR_EXPEDIENTE_VACIO]));
}
